"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var base_1 = require("./base"); // 导出 Action 基类
Object.defineProperty(exports, "Action", { enumerable: true, get: function () { return base_1.default; } });
var register_1 = require("./register");
Object.defineProperty(exports, "createAction", { enumerable: true, get: function () { return register_1.createAction; } });
Object.defineProperty(exports, "registerAction", { enumerable: true, get: function () { return register_1.registerAction; } });
Object.defineProperty(exports, "getActionClass", { enumerable: true, get: function () { return register_1.getActionClass; } });
//# sourceMappingURL=index.js.map